import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// helpful for SSE / fetch streaming
export const apiFetch = (path, init = {}) =>
  fetch(`${API}${path}`, { credentials: "include", ...init });
